// @refresh reset
import React from 'react';
import dynamic from 'next/dynamic';
import { AllAdOptions } from '@/lib/ads';

export interface AdGeneratorProps {
  type: AllAdOptions;
  idCountPosition?: string;
  marginBottomP?: string;
  isPlaceholder?: boolean;
}

export function AdsGenerator({ type, idCountPosition = '', marginBottomP = '', isPlaceholder = false }: AdGeneratorProps) {
  const AdsTypeGenerators = dynamic(() => import('@/components/Ads/Google/AdsTypeGenerators'), { ssr: false });

  return isPlaceholder ? (
    <div className="m-auto mb-8 max-w-[350px] bg-mglGray200 p-[100px] text-center text-mglGray300">PUBLICIDADE</div>
  ) : (
    <AdsTypeGenerators type={type} idCountPosition={idCountPosition} marginBottomP={marginBottomP} />
  );
}

const AdsGeneratorMemo = React.memo(AdsGenerator, () => true);

export default AdsGeneratorMemo;
